import Vue from 'vue'
import VueRouter from 'vue-router'

let Vthis = new Vue()
import $config from '@/config/js/config'
// import HomeView from '../views/HomeView.vue'
const templateName = (path) => () => import(`@/pages/${path}`)

const NotFoundComponent = templateName('err.vue')// 404


const Login = templateName('login.vue')// 登录
const Article = templateName('article/index.vue')// 文章列表
const ArticleNewlyBuild = templateName('article/newlyBuildModify.vue')// 新建文章
const ArticleModify = templateName('article/newlyBuildModify.vue')// 修改文章

const CulRelic = templateName('culturalRelic/index.vue')// 文物列表
const CulRelicNewlyBuild = templateName('culturalRelic/newlyBuildModify.vue')// 新建文物
const CulRelicModify = templateName('culturalRelic/newlyBuildModify.vue')// 修改文物

const Album = templateName('album/index.vue')// 相册列表
const AlbumDetails = templateName('album/details.vue')// 相册详情
const AlbumNewlyBuild = templateName('album/newlyBuildModify.vue')// 新建相册
const AlbumModify = templateName('album/newlyBuildModify.vue')// 修改相册

const Operator = templateName('operator/index.vue')// 运营者列表





const root = Vue.component('root', {
    template: '<router-view></router-view>'
});

const redirectRoute = [{
    path: '/',
    // redirect:'/repertoire',
    redirect: {
        path: '/article'
    },
}]
const unLoginRoute = [

    {
        path: '*',
        name: '404',
        component: NotFoundComponent,
        meta: {
            title:'404',
            isLogin: false, //是否需要登录
            role:[]
        },
    },
    {
        path: '/login',
        name: '登录',
        component: Login,
        meta:{
            title:'修改文章',
            isLogin: false, //是否需要登录
            role:[]
        }
    },
    {
        path: '/album/details/:id',
        name: '相册详情',
        component: AlbumDetails,
        meta:{
            title:'相册详情',
            isLogin: false, //是否需要登录
            role:[]
        }
    },


]

const loginRoute = [{
    path: '/article/newlybuild',
    name: '新建文章',
    component: ArticleNewlyBuild,
    meta: {
        isAside: true, //是否在侧边你菜单栏
        isLogin: true, //是否需要登录
        role: ['ROLE_ADMIN','ROLE_OPERATOR'],
        title:'新建文章'
    }
}, {
    path: '/article/modify/:id',
    name: '修改文章',
    component: ArticleModify,
    meta: {
        isAside: true, //是否在侧边你菜单栏
        isLogin: true, //是否需要登录
        role: ['ROLE_ADMIN','ROLE_OPERATOR'],
        title:'修改文章'
    }
},{
    path: '/culrelic/newlybuild',
    name: '新建文物',
    component: CulRelicNewlyBuild,
    meta: {
        isAside: true, //是否在侧边你菜单栏
        isLogin: true, //是否需要登录
        role: ['ROLE_ADMIN','ROLE_OPERATOR'],
        title:'新建文物'
    }
}, {
    path: '/culrelic/modify/:id',
    name: '修改文物',
    component: CulRelicModify,
    meta: {
        isAside: true, //是否在侧边你菜单栏
        isLogin: true, //是否需要登录
        role: ['ROLE_ADMIN','ROLE_OPERATOR'],
        title:'修改文物'
    }
},{
    path: '/album/newlybuild',
    name: '新建相册',
    component: AlbumNewlyBuild,
    meta: {
        isAside: true, //是否在侧边你菜单栏
        isLogin: true, //是否需要登录
        role: ['ROLE_ADMIN','ROLE_OPERATOR'],
        title:'新建相册'
    }
}, {
    path: '/album/modify/:id',
    name: '修改相册',
    component: AlbumModify,
    meta: {
        isAside: true, //是否在侧边你菜单栏
        isLogin: true, //是否需要登录
        role: ['ROLE_ADMIN','ROLE_OPERATOR'],
        title:'修改相册'
    }
}
]


const asideRoute = [
    {
        path: '/',
        component: root,
        meta: {
            isAside: true,
            isLogin: true,
            role: ['ROLE_ADMIN','ROLE_OPERATOR'],
        },
        children: [
            {
                path: 'article',
                name: '文章列表',
                component: Article,
                meta: {
                    iconClass:'el-icon-document',
                    isAside: true,
                    isLogin: true,
                    role: ['ROLE_ADMIN','ROLE_OPERATOR'],
                    title:'文章列表'
                }
            },{
                path: 'culrelic',
                name: '文物列表',
                component: CulRelic,
                meta: {
                    iconClass:'el-icon-star-on',
                    isAside: true,
                    isLogin: true,
                    role: ['ROLE_ADMIN','ROLE_OPERATOR'],
                    title:'文物列表'
                }
            },{
                path: 'album',
                name: '相册列表',
                component: Album,
                meta: {
                    iconClass:'el-icon-picture',
                    isAside: true,
                    isLogin: true,
                    role: ['ROLE_ADMIN','ROLE_OPERATOR'],
                    title:'文物列表'
                }
            },{
                path: 'operator',
                name: '运营者列表',
                component: Operator,
                meta: {
                    iconClass: 'el-icon-user-solid',
                    isAside: true,
                    isLogin: true,
                    role: ['ROLE_ADMIN'],
                    title:'运营者列表'

                }
            },
        ]

    }

]



const routes = [...redirectRoute,...unLoginRoute, ...loginRoute, ...asideRoute]
// console.log(routes,'routes')
Vue.use(VueRouter)
const router = new VueRouter({
    mode: 'history',
    base: process.env.VUE_APP_BASE_URL,
    routes,
    // strict: true, // applies to all routes
    // sensitive: true
})

// https://vr.n4a.org.cn/index.html
// https://n4a-1252926746.cos.ap-shanghai.myqcloud.com/index.html

router.beforeEach((to,from,next) =>{
    // 路由发生变化 判断将要去的页面的权限
    if($config.getStorageInfo('token')){
        if (to.meta.role.length){
            let isT = $config.authorityJudge(to.meta.role)
            if (!isT){
                Vthis.$message.error('您无权限来浏览-'+to.meta.title)
                next('/article')
            }else{
                next()
            }
        }else{
            next()
        }
    }else{
        next()
    }

})

export default router
